import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { State, useAppDispatch } from "../../../../../../state/store";
import { Loading } from "../../../../common/Loading";
import { getSupporterListAction, initSupporterListAction } from "../../../../../../state/usecase/care_recipient/actions";
import { getAssessmentInfoAction } from "../../../../../../state/usecase/assessment/info/actions";
import { useCareRecipientIdFromPath } from "../../../../../hooks/care_recipient/useCareRecipientIdFromPath";
import { AssessmentInfoProvider } from "../../../../../provider/CareRecipientConfigAssessmentInfoProvider";
import { CareRecipientDetail } from "./CareRecipientDetail";
import { CareRecipientStatus } from "./CareRecipientStatus";
import { DetailSaveButton } from "./DetailSaveButton";
import { FullScreenLoading } from "../../../../common/FullScreenLoading";
import { Mount } from "../../../../common/Mount";
import { Navigate } from "react-router-dom";
import { Paths } from "../../../../../../Paths";

export const AssessmentInfoPage = React.memo(function AssessmentInfoPage() {
    const careRecipientId = useCareRecipientIdFromPath();

    const dispatch = useAppDispatch();

    const { initProcess, updateProcess } = useSelector((state: State) => state.assessmentInfo);

    if (!careRecipientId) {
        return <Navigate to={Paths.root} />;
    }

    useEffect(() => {
        dispatch(initSupporterListAction());
        dispatch(getSupporterListAction(careRecipientId));
        dispatch(getAssessmentInfoAction(careRecipientId));
    }, [dispatch, careRecipientId]);

    // レスポンス取得中
    if (initProcess > 0) return <Loading />;

    return (
        <AssessmentInfoProvider>
            <Mount if={updateProcess > 0}>
                <FullScreenLoading />
            </Mount>
            <div className={"assessment_info_page"}>
                <div className={"assessment_info_container"}>
                    <CareRecipientDetail />
                    <CareRecipientStatus />
                    <DetailSaveButton />
                </div>
            </div>
        </AssessmentInfoProvider>
    );
});
